/* アカデミーサポートクラブ（テーマエディタ版）共通JS
   ・長押し／右クリックメニューの抑止
   ・カルーセルの矢印ボタン
   ・MOVIES：再生中は他の動画を止める／画面外に出たら止める
   ※ 複数のセクションから読み込まれても1回だけ動くようにしてある
   ※ テーマエディタでセクションが再描画されたときも再初期化する（shopify:section:load） */
(function () {
  if (window.__ascInit) return;
  window.__ascInit = true;

  var ARROW = {
    prev: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    next: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  /* 長押し・右クリックメニューの抑止（後から追加されたセクションにも効くよう委譲） */
  document.addEventListener('contextmenu', function (e) {
    if (e.target && e.target.closest && e.target.closest('.asc')) e.preventDefault();
  });

  /* 動画：再生中は他を止める（play は bubble しないので capture で拾う） */
  document.addEventListener('play', function (e) {
    var v = e.target;
    if (!v || !v.closest || !v.closest('.asc')) return;
    document.querySelectorAll('.asc video').forEach(function (other) {
      if (other !== v) other.pause();
    });
  }, true);

  /* 動画：画面外に出たら止める */
  var io = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting && !en.target.paused) en.target.pause();
        });
      }, { threshold: 0.5 })
    : null;

  function initCarousel(carousel) {
    if (carousel.getAttribute('data-asc-ready')) return;
    var track = carousel.querySelector('.asc-carousel__track');
    if (!track) return;
    carousel.setAttribute('data-asc-ready', '1');

    function makeArrow(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'asc-carousel__arrow asc-carousel__arrow--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? '前へ' : '次へ');
      b.innerHTML = ARROW[dir];
      carousel.appendChild(b);
      return b;
    }
    var prev = makeArrow('prev');
    var next = makeArrow('next');

    function stepWidth() {
      var slide = track.querySelector('.asc-carousel__slide');
      if (!slide) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }
    function update() {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -stepWidth(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: stepWidth(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initVideo(v) {
    if (!io || v.getAttribute('data-asc-ready')) return;
    v.setAttribute('data-asc-ready', '1');
    io.observe(v);
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.asc-carousel').forEach(initCarousel);
    scope.querySelectorAll('.asc video').forEach(initVideo);
  }

  /* ---------------------------------------------------------------
     PHOTOS：モーダル（拡大表示＋カルーセル）
     ・カバー画像（.asc-gallery__open）／タイトルをタップ → 同じギャラリー内の .asc-modal を開く
     ・閉じる：×ボタン／Escキー　　切り替え：スワイプ／矢印ボタン／←→キー
     --------------------------------------------------------------- */
  var openModalEl = null;
  var lastFocus = null;
  var modalCurrent = 0;

  function modalTrack(modal) { return modal.querySelector('.asc-modal__track'); }
  function modalTotal(modal) { return modal.querySelectorAll('.asc-modal__slide').length; }

  function updateModal(modal) {
    var track = modalTrack(modal);
    var total = modalTotal(modal);
    var i = track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0;
    i = Math.max(0, Math.min(total - 1, i));
    modalCurrent = i;
    var prev = modal.querySelector('.asc-modal__arrow--prev');
    var next = modal.querySelector('.asc-modal__arrow--next');
    var counter = modal.querySelector('.asc-modal__counter');
    if (prev) prev.disabled = i <= 0;
    if (next) next.disabled = i >= total - 1;
    if (counter) counter.textContent = (i + 1) + ' / ' + total;
  }

  function goToSlide(modal, index, smooth) {
    var track = modalTrack(modal);
    var i = Math.max(0, Math.min(modalTotal(modal) - 1, index));
    track.scrollTo({ left: track.clientWidth * i, behavior: smooth ? 'smooth' : 'auto' });
  }

  function openModal(modal, index, silent) {
    lastFocus = silent ? null : document.activeElement;
    modal.hidden = false;
    document.documentElement.classList.add('asc-modal-open');
    openModalEl = modal;
    goToSlide(modal, index, false);
    updateModal(modal);
    var close = modal.querySelector('.asc-modal__close');
    if (close && !silent) close.focus();
  }

  function closeModal() {
    if (!openModalEl) return;
    openModalEl.hidden = true;
    document.documentElement.classList.remove('asc-modal-open');
    var el = lastFocus;
    openModalEl = null;
    lastFocus = null;
    if (el && el.focus) el.focus();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    /* カバー画像／ギャラリーのタイトルをタップ → そのギャラリーのモーダルを開く */
    var opener = t.closest('.asc-gallery__open, .asc-gallery__title');
    if (opener) {
      var gallery = opener.closest('.asc-gallery');
      var modal = gallery && gallery.querySelector('.asc-modal');
      var btn = gallery && gallery.querySelector('.asc-gallery__open');
      if (modal) openModal(modal, btn ? (parseInt(btn.getAttribute('data-asc-photo'), 10) || 0) : 0);
      return;
    }
    if (t.closest('.asc-modal__close')) { closeModal(); return; }
    var arrow = t.closest('.asc-modal__arrow');
    if (arrow && openModalEl) {
      goToSlide(openModalEl, modalCurrent + (arrow.classList.contains('asc-modal__arrow--prev') ? -1 : 1), true);
    }
  });

  /* スワイプ・矢印による切り替えに合わせて、枚数表示と矢印の有効/無効を更新（scroll は bubble しないので capture） */
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('asc-modal__track') && openModalEl) updateModal(openModalEl);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (!openModalEl) return;
    if (e.key === 'Escape') { e.preventDefault(); closeModal(); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); goToSlide(openModalEl, modalCurrent - 1, true); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); goToSlide(openModalEl, modalCurrent + 1, true); }
    else if (e.key === 'Tab') {
      /* フォーカスをモーダル内に閉じ込める */
      var btns = Array.prototype.filter.call(openModalEl.querySelectorAll('button'), function (b) { return !b.disabled; });
      if (!btns.length) return;
      var first = btns[0], last = btns[btns.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      else if (btns.indexOf(document.activeElement) === -1) { e.preventDefault(); first.focus(); }
    }
  });

  /* 画面の向きが変わったら、表示中の写真の位置を保つ */
  window.addEventListener('resize', function () {
    if (openModalEl) goToSlide(openModalEl, modalCurrent, false);
  });

  /* テーマエディタでセクションが再描画／削除されるときはモーダルを閉じる */
  document.addEventListener('shopify:section:unload', closeModal);

  /* テーマエディタ：「写真」ブロックを選択したら、その写真でモーダルを開く（選択解除で閉じる） */
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target && e.target.closest && e.target.closest('.asc-modal__slide');
    if (!slide) return;
    var modal = slide.closest('.asc-modal');
    var slides = Array.prototype.slice.call(modal.querySelectorAll('.asc-modal__slide'));
    var index = slides.indexOf(slide);
    if (openModalEl && openModalEl !== modal) closeModal();
    if (openModalEl === modal) goToSlide(modal, index, false);
    else openModal(modal, index, true);
  });
  document.addEventListener('shopify:block:deselect', closeModal);

  /* ---------------------------------------------------------------
     ACADEMY FREAKS：「もっと見る」
     ・押すと、非表示の記事（.asc-card[hidden]）をすべて表示し、ボタンを隠す（あとに表示する設定の「一覧」ボタンを出す）
     --------------------------------------------------------------- */
  function revealMore(section) {
    var cards = section.querySelectorAll('.asc-card[hidden]');
    if (!cards.length) return;
    cards.forEach(function (c) { c.hidden = false; });
    var btn = section.querySelector('.asc-more');
    if (btn) { btn.hidden = true; btn.setAttribute('aria-expanded', 'true'); }
    /* 「一覧」ボタンが「もっと見る」のあとに表示する設定のとき、ここで表示する */
    var list = section.querySelector('.asc-list-link');
    if (list) list.hidden = false;
    /* ボタンが消えるので、キーボード操作の人のために、新しく出た最初のリンクへフォーカスを移す */
    if (cards[0].tagName === 'A') cards[0].focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.asc-more');
    if (!btn) return;
    var section = btn.closest('.asc-articles');
    if (section) revealMore(section);
  });

  /* テーマエディタ：非表示になっている記事ブロックを選択したら、全件表示して見えるようにする */
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target && e.target.closest && e.target.closest('.asc-card[hidden]');
    var section = card && card.closest('.asc-articles');
    if (section) revealMore(section);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
